import { Checkbox } from "@mui/material";
import classNames from "classnames";
import useTranslation from "../../hooks/useTranslation";
import {
  ModuleSelectionState,
  TrainingModuleOption,
} from "../../types/actionPlan";
import { TrainingModuleAccordion } from "../TrainingModuleAccordion/TrainingModuleAccordion";
import { Tooltip } from "../ui/Tooltip/Tooltip";
import "./ActionPlanTrainingWizard.scss";

interface TrainingModulePickerProps {
  trainingModuleOptions?: TrainingModuleOption[];
  selectedModules?: TrainingModuleOption[];
  onSelectModule?: (module: TrainingModuleOption, selected: boolean) => void;
}

export const TrainingModulePicker = ({
  trainingModuleOptions,
  selectedModules = [],
  onSelectModule,
}: TrainingModulePickerProps) => {
  const { t } = useTranslation("actionPlanPage");
  return (
    <div className="TrainingModulePicker">
      {trainingModuleOptions?.map((module) => {
        const isBeingUsed = module.state === ModuleSelectionState.BeingUsed;
        const classes = classNames("TrainingModulePicker__item", {
          "TrainingModulePicker__item--disabled": isBeingUsed,
        });

        const isChecked =
          isBeingUsed ||
          selectedModules.some(
            (m) =>
              m.trainingModule.referenceId === module.trainingModule.referenceId
          );

        return (
          <Tooltip
            key={module.trainingModule.referenceId}
            title={
              isBeingUsed ? t("addModules.selectModule.alreadyInPlan") : ""
            }
            disableHoverListener={!isBeingUsed}
          >
            <div className={classes}>
              <Checkbox
                checked={isChecked}
                disabled={isBeingUsed}
                onChange={(e) =>
                  onSelectModule && onSelectModule(module, e.target.checked)
                }
              />
              <TrainingModuleAccordion trainingModule={module.trainingModule} />
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
};
